/* eslint-disable */

import * as ApolloReactComponents from '@apollo/client/react/components';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AppendStructuredBriefDesignersMutationVariables = Types.Exact<{
    id: Types.Scalars['String'];
    designerIds: Array<Types.Scalars['Int']> | Types.Scalars['Int'];
    source: Types.DesignerSource;
}>;

export type AppendStructuredBriefDesignersMutation = {
    __typename: 'Mutation';
    appendStructuredBriefDesigners: {
        __typename: 'StructuredBrief';
        id: string;
        designers: Array<{ __typename: 'User'; id: string }>;
        designersWithSource: Array<{
            __typename: 'DesignerWithSource';
            source: Types.DesignerSource;
        }>;
    };
};

export const AppendStructuredBriefDesignersDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'AppendStructuredBriefDesigners' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'designerIds' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {
                                kind: 'NonNullType',
                                type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                            },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'source' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'DesignerSource' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appendStructuredBriefDesigners' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'designerIds' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'designerIds' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'source' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'source' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'designers' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'designersWithSource' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'source' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type AppendStructuredBriefDesignersMutationFn = Apollo.MutationFunction<
    AppendStructuredBriefDesignersMutation,
    AppendStructuredBriefDesignersMutationVariables
>;
export type AppendStructuredBriefDesignersComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        AppendStructuredBriefDesignersMutation,
        AppendStructuredBriefDesignersMutationVariables
    >,
    'mutation'
>;

export const AppendStructuredBriefDesignersComponent = (
    props: AppendStructuredBriefDesignersComponentProps
) => (
    <ApolloReactComponents.Mutation<
        AppendStructuredBriefDesignersMutation,
        AppendStructuredBriefDesignersMutationVariables
    >
        mutation={AppendStructuredBriefDesignersDocument}
        {...props}
    />
);

/**
 * __useAppendStructuredBriefDesignersMutation__
 *
 * To run a mutation, you first call `useAppendStructuredBriefDesignersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppendStructuredBriefDesignersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appendStructuredBriefDesignersMutation, { data, loading, error }] = useAppendStructuredBriefDesignersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      designerIds: // value for 'designerIds'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useAppendStructuredBriefDesignersMutation(
    baseOptions?: Apollo.MutationHookOptions<
        AppendStructuredBriefDesignersMutation,
        AppendStructuredBriefDesignersMutationVariables
    >
) {
    return Apollo.useMutation<
        AppendStructuredBriefDesignersMutation,
        AppendStructuredBriefDesignersMutationVariables
    >(AppendStructuredBriefDesignersDocument, baseOptions);
}
export type AppendStructuredBriefDesignersMutationHookResult = ReturnType<
    typeof useAppendStructuredBriefDesignersMutation
>;
export type AppendStructuredBriefDesignersMutationResult =
    Apollo.MutationResult<AppendStructuredBriefDesignersMutation>;
export type AppendStructuredBriefDesignersMutationOptions = Apollo.BaseMutationOptions<
    AppendStructuredBriefDesignersMutation,
    AppendStructuredBriefDesignersMutationVariables
>;
